export default __webpack_public_path__ + "static/base-package-tv-35f09225e4fdae1b63adff1e2bd6c936.png";